'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = registerComponent;

var _lang = require('./lang');

function registerComponent() {
  var componentsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if ((0, _lang.isObject)(componentsData)) {
    return componentsData;
  }
  var components = {};
  batRegister(componentsData, components);
  return components;
} /**
   * Register component
   * @param  {Array} componentsData
   * @return {Object} components list
   */

function batRegister(componentsData, components) {
  componentsData.forEach(function (data) {
    var component = data.module || data;
    if (Array.isArray(component)) {
      component.forEach(function (item) {
        if (Array.isArray(item)) {
          return batRegister(item, components);
        }
        if (!item.displayName) {
          (0, _lang.error)(item.name + ' displayName is undefined');
          return;
        }
        components[item.displayName] = item;
      });
    } else {
      if (!component.displayName) {
        (0, _lang.error)(component.name + ' displayName is undefined');
        return;
      }
      components[component.displayName] = component;
    }
  });
}
module.exports = exports['default'];